export default {
  modalTitle: {
    id: 'product_jp_verified_black_friday_special_modal_title',
    defaultMessage: 'Black Friday Sale',
  },
  modalSubTitle: {
    id: 'product_jp_verified_black_friday_special_modal_sub_title',
    defaultMessage: 'Black Friday Sale',
  },
  modalDescription: {
    id: 'product_jp_verified_black_friday_special_modal_description',
    defaultMessage:
      'Limit one per customer. Get 10% OFF your total when you purchase an item priced at ¥20,000 or more (tax included).',
  },
  modalDescriptionHowToUse: {
    id: 'product_jp_verified_black_friday_special_modal_description_how_to_use',
    defaultMessage: 'How to get the discount:',
  },
  modalDescriptionHowToUseStep1: {
    id: 'product_jp_verified_black_friday_special_modal_description_how_to_use_step_1',
    defaultMessage: 'Add the item to your cart and proceed to checkout.',
  },
  modalDescriptionHowToUseStep2: {
    id: 'product_jp_verified_black_friday_special_modal_description_how_to_use_step_2',
    defaultMessage:
      'At checkout, enter the promo code "BMJP2025BF10OFF" to apply a 10% discount* to your cart total.',
  },
  modalDescriptionTermsOfUse1: {
    id: 'product_jp_verified_black_friday_special_modal_description_terms_of_use_1',
    defaultMessage:
      '* Promotion period: November 28, 2025 (Fri) – December 1, 2025 (Mon).',
  },
  modalDescriptionTermsOfUse2: {
    id: 'product_jp_verified_black_friday_special_modal_description_terms_of_use_2',
    defaultMessage:
      '* Please note that the discount will not be applied if your cart contains two or more items.',
  },
  modalDescriptionTermsOfUse3: {
    id: 'product_jp_verified_black_friday_special_modal_description_terms_of_use_3',
    defaultMessage:
      '* In the case of a return due to customer circumstances, the promo code cannot be reissued.',
  },
  modalDescriptionTermsOfUse4: {
    id: 'product_jp_verified_black_friday_special_modal_description_terms_of_use_4',
    defaultMessage:
      '* This promo code is valid for one use per customer and cannot be combined with other promotions.',
  },
  modalDescriptionTermsOfUse5: {
    id: 'product_jp_verified_black_friday_special_modal_description_terms_of_use_5',
    defaultMessage:
      '* Please note that this offer may end early if the planned number of promo codes has been distributed or depending on stock availability.',
  },
}
